import styled from 'styled-components';

export const H1 = styled.h1`
    margin-bottom: 0;
    font-size: 48px;
    letter-spacing: -0.5px;
    color: rgba(0, 0, 0, 0.87);
`;

export const H2 = styled.h2`
    margin-bottom: 0;
    font-size: 34px;
    letter-spacing: -0.25px;
    color: rgba(0, 0, 0, 0.87);
`;

export const H3 = styled.h3`
    margin-bottom: 0;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.87);
`;

export const H4 = styled.h4`
    margin-bottom: 0;
    font-weight: 600;
    font-size: 20px;
    letter-spacing: 0.1px;
    color: rgba(0, 0, 0, 0.87);
`;

export const Subtitle1 = styled.div`
    font-size: 18px;
    color: rgba(0, 0, 0, 0.87);
`;

export const Subtitle2 = styled.div`
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.16px;
    color: rgba(0, 0, 0, 0.87);
`;

export const Subtitle3 = styled.div`
    font-size: 14px;
    letter-spacing: 0.1px;
    color: #212121;
`;

export const Body1 = styled.p`
    margin-bottom: 0;
    font-size: 16px;
    letter-spacing: 0.15px;
    color: rgba(0, 0, 0, 0.87);
`;

export const Body2 = styled.p`
    margin-bottom: 0;
    font-size: 14px;
    letter-spacing: 0.1px;
    color: rgba(0, 0, 0, 0.87);
`;

export const Body3 = styled.p`
    margin-bottom: 0;
    font-size: 12px;
    letter-spacing: 0.4px;
    color: rgba(0, 0, 0, 0.87);
`;

export const Body4 = styled.p`
    margin-bottom: 0;
    font-size: 10px;
    letter-spacing: 0.4px;
    color: #212121;
`;

export const ButtonText = styled.span`
    font-size: 14px;
    letter-spacing: 0.2px;
    color: #212121;
    text-transform: capitalize;
`;

export const OverFlowSubtitle1 = styled(Subtitle1)`
    text-overflow: ellipsis;
    width: auto;
    overflow: hidden;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    white-space: nowrap;
`;

export const OverFlowSubtitle2 = styled(Subtitle2)`
    text-overflow: ellipsis;
    width: auto;
    overflow: hidden;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    white-space: nowrap;
`;

export const OverFlowSubtitle3 = styled(Subtitle3)`
    text-overflow: ellipsis;
    width: auto;
    overflow: hidden;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    white-space: nowrap;
`;

export const OverFlowBody1 = styled(Body1)`
    text-overflow: ellipsis;
    width: auto;
    overflow: hidden;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    white-space: nowrap;
`;
export const OverFlowBody2 = styled(Body2)`
    text-overflow: ellipsis;
    width: auto;
    overflow: hidden;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    white-space: nowrap;
`;

export const OverFlowBody3 = styled(Body3)`
    text-overflow: ellipsis;
    width: auto;
    overflow: hidden;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    white-space: nowrap;
`;
